module.exports = __webpack_public_path__ + "img/leftArrowCalendar.b410603e.svg";